'use strict';

import passRules from '../../modules/passRules';

const password = {
  settings: {
    $form: document.querySelector('.form-signin'),
  },

  init() {
    passRules.init();

    s.$form.length &&
      s.$form.addEventListener('submit', function (e) {
        if (!passRules.settings.submit) {
          e.preventDefault();
        }
      });
  },
};

const s = password.settings,
  _this = password;

export default _this;
